'use client'

import { SessionProvider } from 'next-auth/react'

import { Toaster, TooltipProvider } from '@/components/ui'
import { BarcodeReader } from '@/components/molecules'
import { LoaderProvider } from '@/components/providers/loader-provider'
import { ModalProvider } from '@/components/providers/modal-provider'
import { RefProvider } from '@/components/providers/ref-provider'
import { StoreProvider } from '@/components/providers/store-provider'

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider>
      <StoreProvider>
        <RefProvider>
          <ModalProvider>
            <TooltipProvider delayDuration={10}>{children}</TooltipProvider>
          </ModalProvider>
          <Toaster
            className="hidden lg:block"
            position="top-right"
            richColors
            duration={1000}
            theme="light"
          />
          <Toaster
            className="lg:hidden"
            position="bottom-right"
            richColors
            duration={1000}
            theme="light"
          />
          <LoaderProvider />
          <BarcodeReader />
        </RefProvider>
      </StoreProvider>
    </SessionProvider>
  )
}
